var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loggedIn)?_c('PollComponent',{staticClass:"mb-4"}):_vm._e(),_c('calendar',{staticClass:"mb-4"}),_c('link-box-component',{staticClass:"mb-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }